<template>
	<v-container class="ma-0 pa-0" fluid>
		
		<SlideshowComponent/>
		
		<v-row row-wrap class="ma-6">
			<QualityColumn v-for="(q, index) in qualities"
			:key="index"
			:iconName="q.iconName"
			:headText="q.headText"
			:description="q.description"/>
		</v-row>
		<v-row row-wrap>
			<v-col cols="3" class="mx-auto mb-8" align-self="center">
				<v-divider class="primary"></v-divider>
			</v-col>
		</v-row>
		
		<v-row row-wrap class="pa-0 ma-0">
			<v-col cols="7" class="ma-0 pa-0 pl-3 block-text" v-html="cibText"/>

			<v-col cols="5" class="ma-0 pa-0">
				<img :src="rowImageOne" class="row-image image-float-right"/>
			</v-col>
		</v-row>
		
		<v-row row-wrap cols="12" class="rowback pa-0 ma-0" height="300px">
			<v-col cols="2" class="pa-0">
				<img :src="rowImageTwo" class="row-image"/>
			</v-col>
		</v-row>
		
		
		
		
		<v-row row-wrap cols="12">
			<v-col cols="7" class="block-text ma-5 pa-0" v-html="welcomeText"/>			
			<v-col cols="3" class="pa-0 rowus">
				<img class="row-image" :src="rowImageThree"/>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import QualityColumn from "../widgets/QualityColumn.vue"
import SlideshowComponent from "../widgets/Slideshow.vue"
import mdTexts from "../../MarkdownTexts.js"
import markdownService from "../../services/mdService.js"

export default {
	name: "StartComponent",
	
	components: {
		QualityColumn,
		SlideshowComponent,
	},
	
	data: function() {
		return {
			qualities: [
				{
					iconName: "mdi-star",
					headText: "SAP",
					description: "Im ERP und Logistikbereich setzen wir in Zusammenarbeit mit Ihnen, ganz individuell Ihre Ideen auf Basis modernster SAP Systeme - einschließlich SAP Hana - um. Als zentrales Steuerelement in Ihrem Unternehmen für die gesamte Abwicklung oder portalbasiert und optimiert für Ihre Mobilstrategie.",
				},
				
				{
					iconName: "mdi-grid",
					headText: "Big Data",
					description: "Wo komplexe und viele Datenmengen aufkommen, ist eine intelligente Verwaltung und Analyse dieser nicht nur notwendig, sondern unerlässlich, um wirtschaftlichen Erfolg zu haben. Wir geben Ihnen die Werkzeuge und das Know-How um Ihre Daten effektiv zu nutzen.",
				},
				
				{
					iconName: "mdi-chevron-double-right",
					headText: "Automatisierung",
					description: "Industrielle Produktionsprozesse erfordern eine kontinuierliche, automatisierte und zentralisierte Überwachung und Steuerung. Wir entwickeln mit Ihnen effiziente Steuersysteme, Lösungen für Prozessleitstände sowie die Kopplung an Ihre Auftragssysteme (bspw. SAP)",
				},
				
				{
					iconName: "mdi-cogs",
					headText: "Individualsoftware",
					description: "Spezifische Aufgaben erfordern individuelle Betrachtung. Wir helfen Ihnen, zielgerichtete und auf Ihre Wünsche und Probleme zugeschnittene System zu schaffen. Durch individuelle Software erreichen Sie ein effizienteres Arbeiten und besseres Datenhandling.",
				}
			],
			
			cibHeadline: String,
			cibText: String,
			welcomeHeadline: String,
			welcomeText: String,
			
			rowImageOne: require("../../assets/rowimage-1.jpg"),
			rowImageTwo: require("../../assets/rowimage-2.jpg"),
			rowImageThree: require("../../assets/rowimage-3.png"),
		}
	},
	
	async created() {
		var md = mdTexts;
		var mdService = new markdownService();
		this.cibHeadline = await mdService.convertMarkdown(md.cibText);
		this.cibText = mdService.convertMarkdown(md.cibText);
		this.welcomeHeadline = mdService.convertMarkdown(md.welcomeOffersText);
		this.welcomeText = mdService.convertMarkdown(md.welcomeText);
	}
	
}
</script>

<style scoped>
	.secondary-headline {
		color: #824003;
	}
	
	.row-image {
		max-width: 100%;
		min-width: 450px;
		width: auto;
		height: auto;
	}
	
	.rowus .row-image {
		padding-top: 4em;
	}
	
	.rowback .row-image {
		max-height: 300px;
		min-height: 300px;
	}
	
	.block-text >>> h2 {
		color: #ca6302;
		font-size: 30px;
		font-weight: normal;
		padding-top: 0.5em;
		padding-bottom: 0.5em;
	}
	
	.image-float-right {
		float: right;
	}

</style>